module.exports = __webpack_public_path__ + "static/media/carroussel_24.8e0fba12.jpg";